import LieuSummary from '@/generated/controls/lieu/LieuSummary.vue';
import Lieu from '@/generated/classes/Lieu';
import PlageCreneau from '@/generated/classes/PlageCreneau';
import Owner from '@/extend/classes/Owner';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: LieuSummary,
    methods: {
        getDisplay(lieu: Lieu): string {
            const jauge = lieu.graphAnswers.find(a => a.donnee == 'jauge')
            if (jauge) {
              return lieu.label + ' (' + jauge.value + ' places)';
            } else {
              return lieu.label;
            }
        },
        setAttribut(lieu: Lieu, owner: Owner, parentObj: unknown): void {
            lieu.owner = owner;
            if (parentObj) {
              lieu.parentObj = parentObj as PlageCreneau;
            }
        }
    }
})
